module.exports = __webpack_public_path__ + "static/img/297_TO8_1931_og.8e3cb54.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/297_TO8_1931_og.jpg
// module id = 4QzF
// module chunks = 0